import { App } from "../data/statics/enums";
import { hosts } from "./hosts";

/** Route Definitions (excluding domain) Organized By App
 *
 * Please note that the base urls are relative here. If the full url is needed
 * the `fullRoutes` export should be used.
 */
export const routes = {
  [App.Core]: {
    base: "/",
    signIn: "/sign-in",
    signUp: "/sign-up",
    signOut: "/sign-out",
    oauthCallback: "/oauth/cb",
    confirmEmail: "/confirm-email",
    password: {
      forgotPassword: "/forgot-password",
      verifyCode: "/verify-code",
    },
    mfa: {
      sms: {
        verify: "/mfa/sms/verify",
      },
      totp: {
        verify: "/mfa/totp/verify",
      },
    },
  },

  [App.Account]: {
    base: "/",
    edit: {
      twoFactor: {
        base: "/two-factor/edit",
        modal: "/two-factor/edit/:modal",
        confirmChangeEmail: "/two-factor/edit/verify-email",
        sms: {
          activate: "/two-factor/edit/sms-activate",
          deactivate: "/two-factor/edit/sms-deactivate",
        },
        totp: {
          activate: "/two-factor/edit/totp-activate",
          deactivate: "/two-factor/edit/totp-deactivate",
        },
      },
      email: "/email/edit",
      password: "/password/edit",
      name: "/name/edit",
      company: "/company/edit",
      profilePicture: "/profile-picture/edit",
      history: "/history/edit",
      terminateAccount: "/account/edit",
    },
    logs: "/logs",
  },

  [App.Admin]: {
    base: "/",
    users: "/users",
    upstreamProviders: "/upstream-providers",
    orgs: "/orgs",
    user: {
      base: "/user/:userId",
      modal: "/user/:userId/:modal",
      edit: {
        attributes: {
          base: "/user/:userId/edit",
          modal: "/user/:userId/edit/:modal",
        },
        profilePicture: {
          base: "/user/:userId/profile-picture",
          modal: "/user/:userId/profile-picture/:modal",
        },
        terminateAccount: {
          base: "/user/:userId/terminate-account",
          modal: "/user/:userId/terminate-account/:modal",
        },
      },
      logs: { base: "/user/:userId/logs", modal: "/user/:userId/logs/:modal" },
    },
  },
} as const;

/** Prepare Full Routes
 *
 * This helper function prepares all routes for use within any app
 * by adding env specific hosts to generate full endpoint urls
 *
 * @returns - All fully formed routes separated by app
 */
function prepareFullRoutes() {
  const result = Object.entries(routes).map(([id, _routes]) => {
    // Add the appropriate domain to all routes...
    const _base = `${hosts.frontend[id as App]}${_routes.base}`;
    const _rest = JSON.parse(
      JSON.stringify(_routes)
        .replace(/:"/g, `:"${_base}`) // prepend base url
        .replace(/([^:])(\/\/+)/g, "$1/"), // remove double slashes
    );

    return [
      id,
      {
        base: _base,
        ..._rest,
      },
    ];
  });

  return Object.fromEntries(result) as typeof routes;
}

/** Route Definitions (including domain) Organized By App
 *
 * Please note that these are full urls including the domain. If relative urls
 * are needed the `routes` export should be used.
 */
export const fullRoutes = prepareFullRoutes();
